import Avatar9 from '../../assets/images/xs/avatar9.svg';
import Avatar2 from '../../assets/images/xs/avatar2.svg';
import Avatar3 from '../../assets/images/xs/avatar3.svg';
import Avatar12 from '../../assets/images/xs/avatar12.svg';


export const ReviewDiscriptionData=[
    {
        image:Avatar9,
        name:'Joan Dyer',
        time:'3 hours ago',
        productname:'Top-Oculus VR',
        productdiscription:'A good fit for many households, this Oculus VR has a movable deli drawer and door shelves that can accommodate gallon containers.Though its low price means fewer features, this pick is quiet and an energy-saving option, resulting in a lower energy bill.',
        type:'first'
    },
    {
        image:Avatar2,
        name:'Phil Glover',
        time:'1 Day ago',
        productname:'Oculus VR Full 3D',
        productdiscription:'I purchased this Oculus from elsewhere, on last Dipawali. As this Oculus contains in-built DDB( means you need not to install a separate set-top box), there is less number of wire hanging around the set and single remote required. Great full HD picture quality. Sound quality of the set is far better than most of the sets of the so called big brands.',
        type:'first'
    },
    {
        image:Avatar3,
        name:'Victor Rampling',
        time:'5 Day ago',
        productname:'Oculus VR  Wireless Bluetooth',
        productdiscription:'The build quality feels really premium.Sound quality is quite great compared to its price point.Sound quality is quite great compared to its price point.',
        img:Avatar12,
        secondname:'Karen Clark',
        secondtime:'Hd quality is quite great compared to its price point.',
        type:'second'
    }
]